// Libs
import React from 'react';
import { Box } from '@mui/material';

// Components
import Spinner from '../../../components/Spinner';
import Error from '../../../components/Error';
import Table from '../../../components/Table';
import TableRow from '../../../components/Kits/TableRow/TableRow';
import EmptyKitsScreen from '../../../components/Kits/EmptyKitsScreen/EmptyKitsScreen';
import TotalQtyLabel from '../../../components/Labels/TotalQtyLabel';
import KitsBar from '../../../components/Kits/KitsBar/KitsBar';
import SharedKitAdaptiveCard from '../../../components/Kits/SharedKitAdaptiveCard/SharedKitAdaptiveCard';

// Hooks
import useSharedKits from '../hooks/useSharedKits';
import useSharedKitsCellsReducers from '../hooks/useSharedKitsCellsReducers';
import useUI from '../../../hooks/useUI';
import useUser from '../../../hooks/useUser';

// Constants
import {
  emptySharedKitsMessage,
  sharedKitsTableColumns,
} from '../../../constants/sharedKits';

// Styles
import { useTableStyles } from './SharedKitsStyles';

const SharedKits = () => {
  const { isKiteUser } = useUser();
  const { isTabletMode } = useUI();
  const { isLoading, sharedKits, filteredKits, apiError } = useSharedKits();
  const { classes: tableClasses } = useTableStyles({ isKiteUser });

  const hasKits = sharedKits.data !== null && sharedKits?.data?.length > 0;

  const renderContent = () => {
    if (isLoading) {
      return <Spinner />;
    }

    if (apiError) {
      return <Error message={apiError} />;
    }

    if (!hasKits) {
      return (
        <EmptyKitsScreen
          message={emptySharedKitsMessage}
          withRedirectButton={false}
        />
      );
    }

    return (
      <>
        <TotalQtyLabel qty={filteredKits.length} type={'kit'} />
        {isTabletMode ? (
          <Box mt={1}>
            {filteredKits.map((kit) => (
              <SharedKitAdaptiveCard key={kit.id} kit={kit} />
            ))}
          </Box>
        ) : (
          filteredKits.length > 0 && (
            <Table
              data={filteredKits}
              useCellsReducers={useSharedKitsCellsReducers}
              columns={sharedKitsTableColumns}
              styles={tableClasses}
              TableRow={TableRow}
            />
          )
        )}
      </>
    );
  };

  return (
    <>
      <KitsBar />
      {renderContent()}
    </>
  );
};

export default SharedKits;
